(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:ApplicationService
     *
     * @description
     *
     */

    /**
	  * If any pages are added,specify the 'pageBelongsToTheMenu' property.
	  * 'pageBelongsToTheMenu' : indicates the category of the page according side menu structure(crews,flight,training,messageAdmin,settings,reports).
	  * Helps to show the active menu icon of the selected page.
	  */

    angular
        .module('commons')
        .service('ApplicationService', ApplicationService);

    function ApplicationService(StorageServices, EventManagerService) {


        var self = this,
            loginInfo,
            lastServiceCallTimeStamp,
            lastTokenRecivedTimeStamp,
            tabSettings = {
                selectedTab: '',
                allOpenTabs: [],
                allTabbableState: [
                   {
                	   id: '1',
                	   name: 'Rosters',
                	   state: 'crewing',
                	   view: 'crewingView',
                	   closable : true,
                	   favicon : 'favicon_crew_watch.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '2',
                	   name: 'Flight Watch',
                	   state: 'flightWatch',
                	   view: 'flightWatchView',
                	   closable : true,
                	   favicon : 'favicon_flight_watch.ico',
                	   pageBelongsToTheMenu : 'flight'
                   },
                   {
                	   id: '3',
                	   name: 'Manage Pairing',
                	   state: 'managePairing',
                	   view: 'managePairingView',
                	   closable : true,
                	   favicon : 'favicon_manage_pairings.ico',
                	   pageBelongsToTheMenu : 'flight'
                   },
                   {
                	   id: '4',
                	   name: 'Create Pairing',
                	   state: 'createPairing',
                	   view: 'createPairingView',
                	   closable : true,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '5',
                	   name: 'Crew Schedule',
                	   state: 'crewSchedule',
                	   view: 'crewScheduleView',
                	   closable : true,
                	   favicon : 'favicon_crew_schedule.ico',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '6',
                	   name: 'Trainings',
                	   state: 'trainingPrograms',
                	   view: 'trainingProgramsView',
                	   closable : true,
                	   favicon : 'favicon_traning.ico',
                	   pageBelongsToTheMenu : 'training'
                   },
                   {
                	   id: '7',
                	   name: 'Crew Profile',
                	   state: 'crewProfile',
                	   view: 'profileView',
                	   closable : true,
                	   favicon : 'favicon_crew_profile.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '8',
                	   name: 'Training Schedule',
                	   state: 'trainingSchedule',
                	   view: 'trainingScheduleView',
                	   closable : true,
                	   favicon : 'favicon_training_schedule.ico',
                	   pageBelongsToTheMenu : 'training'
                   },
                   {
                	   id: '9',
                	   name: 'Home',
                	   state: 'home',
                	   view: 'homeView',
                	   closable : true,
                	   favicon : 'favicon_default.ico',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '10',
                	   name: 'Crew Watch',
                	   state: 'tracking',
                	   view: 'trackingView',
                	   closable : true,
                	   favicon : 'favicon_tracking.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '11',
                	   name: 'Fuel Suppliers',
                	   state: 'fuelSuppliers',
                	   view: 'fuelSuppliersView',
                	   closable : true,
                	   favicon : 'favicon_tracking.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '12',
                	   name: 'Fuel Prices',
                	   state: 'fuelPrices',
                	   view: 'fuelPricesView',
                	   closable : true,
                	   favicon : 'favicon_feul.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '13',
                	   name: 'Fuel Uplift Report',
                	   state: 'fuelUpliftReport',
                	   view: 'fuelUpliftReportView',
                	   closable : true,
                	   favicon : 'favicon_feul.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '14',
                	   name: 'Auto Roster Schedule',
                	   state: 'autoRosterSchedule',
                	   view: 'autoRosterScheduleView',
                	   closable : true,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '15',
                	   name: 'Document Manager',
                	   state: 'documentManager',
                	   view: 'documentManagerView',
                	   closable : true,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'documentManager'
                   },

                   {
                	   id: '16',
                	   name: 'Crew Batches',
                	   state: 'adminCrewBatchers',
                	   view: 'adminCrewBatchersView',
                	   pageBelongsToTheMenu : 'crews'
                   },

                   {
                	   id: '17',
                	   name: 'Aircraft Registration',
                	   state: 'aircraftRegistration',
                	   view: 'acRegView',

                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '18',
                	   name: 'Manage User',
                	   state: 'manageUser',
                	   view: 'manageUserView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '19',
                	   name: 'Alert',
                	   state: 'alertManager',
                	   view: 'alertManagerView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : ''

                   },
                   {

                	   id: '20',
                	   name: 'Admin Manage Roles',
                	   state: 'manageRoles',
                	   view: 'manageRoleView',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '21',
                	   name: 'Crew Validation',
                	   state: 'crewValidation',
                	   view: 'crewValidationView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'training'

                   },
                   {
                	   id: '22',
                	   name: 'Airport',
                	   state: 'airport',
                	   view: 'airportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'settings'

                   },
                   {
                	   id: '23',
                	   name: 'Cycle',
                	   state: 'cycle',
                	   view: 'cycleView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '24',
                	   name: 'Configure Tracking Color',
                	   state: 'configureTrackingColor',
                	   view: 'trackigColorView',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '25',
                	   name: 'Training Discrepancy',
                	   state: 'trainingDiscrepancy',
                	   view: 'trainingDiscrepancyView',
                	   pageBelongsToTheMenu : 'training'
                   },
                   {
                	   id: '26',
                	   name: 'Distribution Limitation',
                	   state: 'patternLimitation',
                	   view: 'patternLimitationView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {

                	   id: '27',
                	   name: 'Renewals',
                	   state: 'renewals',
                	   view: 'renewalsView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },

                   {
                	   id: '28',
                	   name: 'Manage Flights',
                	   state: 'manageFlight',
                	   view: 'manageFlightView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'flight'
                   },

                   {   id: '29',
                	   name: 'Hard and Soft Rule',
                	   state: 'hardSoftRule',
                	   view: 'hardSoftRuleView',
                	   pageBelongsToTheMenu : 'settings'

                   },
                   {
                	   id: '30',
                	   name: 'Distribution Group',
                	   state: 'configDistribution',
                	   view: 'configDistributionView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '31',
                	   name: 'Application Parameters',
                	   state: 'applicationParameters',
                	   view: 'applicationParametersView',
                	   closable : false,
                	   favicon : 'favicon_tracking.ico',
                	   pageBelongsToTheMenu : 'settings'

                   },
                   {
                	   id: '32',
                	   name: 'Bidding',
                	   state: 'bidding',
                	   view: 'biddingView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '33',
                	   name: 'Duty Sheet',
                	   state: 'dutySheet',
                	   view: 'dutySheetView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '34',
                	   name: 'Print GD',
                	   state: 'printGD',
                	   view: 'printGDView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '35',
                	   name: 'Target Hours',
                	   state: 'targetHours',
                	   view: 'targetHourView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                	   id: '35',
                	   name: 'Print Journey Log',
                	   state: 'printJourneyLog',
                	   view: 'printJourneyLogView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '36',
                	   name: 'Print Duty Sheet',
                	   state: 'printDutySheet',
                	   view: 'printDutySheetView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : ''
                   } ,
                   {
                	   id: '37',
                	   name: 'Individual Crew Expiry Log Report',
                	   state: 'indiCrewExpiryLog',
                	   view: 'indiCrewExpiryLogView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   } ,
                   {
                	   id: '38',
                	   name: 'Active Inactive Crew List Report',
                	   state: 'activeInactiveCrewList',
                	   view: 'activeInactiveCrewListView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {	id: '39',
                	   name: 'Electronic Log Book Report',
                	   state: 'electronicLogBook',
                	   view: 'electronicLogBookView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '40',
                	   name: 'Individual Crew Schedule Report',
                	   state: 'individualCrewScheduleReport',
                	   view: 'individualCrewScheduleReportView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '41',
                	   name: 'Flying Schedule Report',
                	   state: 'flyingScheduleReport',
                	   view: 'flyingScheduleReportView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '42',
                	   name: 'Crewing Report',
                	   state: 'crewingReport',
                	   view: 'crewingReportView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '43',
                	   name: 'Message Admin',
                	   state: 'messageAdmin',
                	   view: 'messageAdminView',
                	   closable : false,
                	   pageBelongsToTheMenu : 'messageAdmin'
                   },
                   {
                	   id: '44',
                	   name: 'General Flight Report',
                	   state: 'generalFlightReport',
                	   view: 'generalFlightReportView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '45',
                	   name: 'Crew APP',
                	   state: 'paxMessage',
                	   view: 'paxMessageView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '46',
                	   name: 'Crew APP/APIS Configurations',
                	   state: 'paxMessageConfig',
                	   view: 'paxMessageConfigView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                	   id: '47',
                	   name: 'Missing Sign In & Out Report',
                	   state: 'missingSignIn',
                	   view: 'missingSignInView',
                	   pageBelongsToTheMenu : ''
                   },
                   {
                	   id: '48',
                	   name: 'Flight Information Report',
                	   state: 'flightInformationReport',
                	   view: 'flightInformationReportView',
                	   closable : false,
                	   favicon : 'favicon_create_pairing.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '49',
                	   name: 'Base Wise Layover Report',
                	   state: 'baseWiseLayoverReport',
                	   view: 'baseWiseLayoverReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '50',
                	   name: 'Crew Base Assignment Report',
                	   state: 'crewBaseAssignmentReport',
                	   view: 'crewBaseAssignmentReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '51',
                	   name: 'OTP Report',
                	   state: 'otpReport',
                	   view: 'otpReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '51',
                	   name: 'Daily OPS Report',
                	   state: 'dailyOpsReport',
                	   view: 'dailyOpsReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '52',
                	   name: 'Flight Delay Report',
                	   state: 'flightDelayReport',
                	   view: 'flightDelayReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '53',
                	   name: 'Flight Block Time Report',
                	   state: 'flightBlockTimeReport',
                	   view: 'flightBlockTimeReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '54',
                	   name: 'Flight Pax Count Report',
                	   state: 'flightPaxCountReport',
                	   view: 'flightPaxCountReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '55',
                	   name: 'Performance Detail Report',
                	   state: 'performanceDetailReport',
                	   view: 'performanceDetailReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '56',
                	   name: 'Crew Set Report',
                	   state: 'crewSetReport',
                	   view: 'crewSetReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '57',
                	   name: 'Aircraft Utilization Report',
                	   state: 'acUtilizationReport',
                	   view: 'acUtilizationReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '58',
                	   name: 'Leave Details Report',
                	   state: 'leaveDetailReport',
                	   view: 'leaveDetailReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '59',
                	   name: 'Fuel Price Report',
                	   state: 'fuelPriceReport',
                	   view: 'fuelPriceReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '60',
                	   name: 'Dead Heading Report',
                	   state: 'deadHeadingReport',
                	   view: 'deadHeadingReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '61',
                	   name: 'Crew Sales Report',
                	   state: 'crewSalesReport',
                	   view: 'crewSalesReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '62',
                	   name: 'ETS Report',
                	   state: 'etsReport',
                	   view: 'etsReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '63',
                	   name: 'Leaves Report',
                	   state: 'leaveReport',
                	   view: 'leaveReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '64',
                	   name: 'Crew Downloads Report',
                	   state: 'crewDownloads',
                	   view: 'crewDownloadsView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '65',
                	   name: 'App File Download Report',
                	   state: 'appFileDownload',
                	   view: 'appFileDownloadView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '66',
                	   name: 'Fuel Burn Discrepancy Report',
                	   state: 'fuelBurnDiscrepancy',
                	   view: 'fuelBurnDiscrepancyView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '67',
                	   name: 'Cabin Flight Issues Report',
                	   state: 'cabinFlightIssues',
                	   view: 'cabinFlightIssuesView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '68',
                	   name: 'Missing ETS Report',
                	   state: 'missingEtsReport',
                	   view: 'missingEtsReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '69',
                	   name: 'Crew Hours Report',
                	   state: 'crewHourReport',
                	   view: 'crewHourReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '70',
                	   name: 'Roster Stability Report',
                	   state: 'rosterStability',
                	   view: 'rosterStabilityView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '71',
                	   name: 'Missing Patterns Report',
                	   state: 'missingPatternsReport',
                	   view: 'missingPatternsReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '72',
                	   name: 'Crew Expiry Log Report',
                	   state: 'crewExpiryLogReport',
                	   view: 'crewExpiryLogReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '73',
                	   name: 'Crew Airport Expiry Report',
                	   state: 'crewAirportExpiryReport',
                	   view: 'crewAirportExpiryReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '74',
                	   name: 'Crew Water Consumption Report',
                	   state: 'crewWaterConsumption',
                	   view: 'crewWaterConsumptionView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '75',
                	   name: 'Cabin Performance Comment Report',
                	   state: 'cabinPerformanceComment',
                	   view: 'cabinPerformanceCommentView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '76',
                	   name: 'Crew Sign In Report',
                	   state: 'crewSignInReport',
                	   view: 'crewSignInReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'reports'
                   },
                   {
                	   id: '77',
                	   name: 'Request Respected Report',
                	   state: 'requestRespectedReport',
                	   view: 'requestRespectedReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '78',
                	   name: 'FDP Violation Report',
                	   state: 'fdpViolationReport',
                	   view: 'fdpViolationReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '79',
                	   name: 'Seniority List Report',
                	   state: 'seniorityList',
                	   view: 'seniorityListView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '80',
                	   name: 'Crew Flying Experience Report',
                	   state: 'crewFlyingExperiance',
                	   view: 'crewFlyingExperianceView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '81',
                	   name: 'Roster Checking Report',
                	   state: 'rosterChecking',
                	   view: 'rosterCheckingView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '82',
                	   name: 'Flying Hours Allowance Report',
                	   state: 'flyingHoursAllowance',
                	   view: 'flyingHoursAllowanceView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '83',
                	   name: 'Slip Allowance Report',
                	   state: 'slipAllowanceReport',
                	   view: 'slipAllowanceReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '84',
                	   name: 'ALV Bidding Report',
                	   state: 'alvBidding',
                	   view: 'alvBiddingView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '85',
                	   name: 'Crew Punctuality Report',
                	   state: 'crewPunctualityReport',
                	   view: 'crewPunctualityReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '86',
                	   name: 'Cabin Performance Report',
                	   state: 'cabinPerformance',
                	   view: 'cabinPerformanceView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id : '87',
                	   name : 'Monthly Flight Time Report',
                	   state : 'monthlyFlightTime',
                	   view : 'monthlyFlightTimeView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                       id: '88',
                       name: 'Welcome',
                       state: 'welcome',
                       view: 'welcomeView',
                       closable : false,
                       favicon : 'favicon_crew_roster.ico',
                       pageBelongsToTheMenu : 'welcome'
                   },
                   {
                	   id: '89',
                	   name: 'Crew Flying Details Report',
                	   state: 'crewFlyingDetailsReport',
                	   view: 'crewFlyingDetailsReportView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
                	   id: '90',
                	   name: 'Payments Report',
                	   state: 'payment',
                	   view: 'paymentView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico'
                   },
                   {
	               	   id: '91',
	               	   name: 'Great Circle Distance',
	               	   state: 'greatCircleDistance',
	               	   view: 'greatCircleDistanceView',
	               	   closable : false,
	               	   favicon : 'favicon_crew_roster.ico',
	               	   pageBelongsToTheMenu : 'settings'
                   },
                   {
                  	   id: '92',
                  	   name: 'Flight Cargo',
                  	   state: 'flightCargo',
                  	   view: 'flightCargoView',
                  	   closable : false,
                  	   favicon : 'favicon_crew_roster.ico',
                  	   pageBelongsToTheMenu : 'flight'
                   },
                   {
                	   id: '93',
                	   name: 'Payment Rates',
                	   state: 'paymentRates',
                	   view: 'paymentRatesView',
                	   closable : false,
                	   favicon : 'favicon_crew_roster.ico',
                	   pageBelongsToTheMenu : 'crews'
                   },
                   {
                 	   id: '94',
                 	   name: 'ACARS Messages',
                 	   state: 'acarsMessages',
                 	   view: 'acarsMessagesView',
                 	   closable : false,
                 	   favicon : 'favicon_create_pairing.ico',
                 	   pageBelongsToTheMenu : 'flight'
                    },
                    {
                   	   id: '95',
                   	   name: 'Message Inbox',
                   	   state: 'messageInbox',
                   	   view: 'messageInboxView',
                   	   closable : false,
                   	   pageBelongsToTheMenu : 'messageAdmin'
                    },
                    {
                		id: '96',
                	    name: 'Crew Flight Reports',
                	    state: 'flightReports',
                	    view: 'flightReportsView',
                	    closable : false,
                	    pageBelongsToTheMenu : 'crews'
                     },
                     {
                 	  	id: '97',
                 	    name: 'Voyage report',
                 	    state: 'voyageReport',
                 	    view: 'voyageReportView',
                 	    closable : false,
                 	    pageBelongsToTheMenu : 'flight'
                      },
                      {
                 	  	id: '98',
                 	    name: 'Cabin Flight Admin',
                 	    state: 'cabinFlightAdmin',
                 	    view: 'cabinFlightAdminView',
                 	    closable : false,
                 	    pageBelongsToTheMenu : 'flight'
                      },
                      {
                      	id: '99',
                      	name: 'Flight Punctuality',
                      	state: 'flightPunctuality',
                      	view: 'flightPunctualityView',
                      	closable : false,
                      	pageBelongsToTheMenu : 'flight'
                      },
                      {
                    	id: '100',
                    	name: 'Training Allowance Report',
                    	state: 'trainingAllowanceReport',
                    	view: 'trainingAllowanceReportView',
                    	closable : false,
                    	pageBelongsToTheMenu : 'crew'
                      } ,
                      {
                    	id: '101',
                    	name: 'Individual Flying Hours Report',
                    	state: 'individualFlyingHours',
                    	view: 'individualFlyingHoursView',
                    	closable : false,
                    	pageBelongsToTheMenu : 'crew'
                      },
                      {
                   	   id: '103',
                   	   name: 'Flying Hours Summary Report',
                   	   state: 'flyingHourSummaryReport',
                   	   view: 'flyingHourSummaryReportView',
                   	   closable : false,
                   	   favicon : 'favicon_crew_roster.ico',
                   	   pageBelongsToTheMenu : 'crew'
                      },

                      {
                        id: '104',
                        name: 'Sage Flight Data Report',
                        state: 'sageFlightDataReport',
                        view: 'sageFlightDataReportView',
                        closable : false,
                        favicon : 'favicon_crew_roster.ico',
                        pageBelongsToTheMenu : 'reports'
                      },
                      {
                        id: '105',
                        name: 'Meal Details',
                        state: 'mealDetail',
                        view: 'mealDetailView',
                        closable : false,
                        pageBelongsToTheMenu : 'flight'
                      },
                     {
	                    id: '106',
	                    name: 'Training Cost Report',
	                    state: 'trainingCostReport',
	                    view: 'trainingCostReportView',
	                    closable : false,
	                    favicon : 'favicon_create_pairing.ico',
	                    pageBelongsToTheMenu : 'reports'
                     },
                      {
                        id: '107',
                        name: 'Flight Crew Notification Log Report',
                        state: 'notificationsLog',
                        view: 'notificationsLogView',
                        closable : false,
                        favicon : 'favicon_crew_roster.ico',
                        pageBelongsToTheMenu : 'reports'
                      },
                     {
                    	id: '108',
                        name: 'Training Automation',
                        state: 'trainingAutomation',
                        view: 'trainingAutomationView',
                        closable : false,
                        pageBelongsToTheMenu : 'training'
                      },
                      {
                      id: '109',
                      name: 'Training Roster',
                      state: 'trainingRoster',
                      view: 'trainingRosterView',
                      closable : false,
                      pageBelongsToTheMenu : 'training'
                    },
                  {
                    id: '110',
                    name: 'Training Audit Report',
                    state: 'trainingAuditReport',
                    view: 'trainingAuditReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '129',
                    name: 'User Activity Audit Report',
                    state: 'userActivityAuditReport',
                    view: 'userActivityAuditReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '111',
                    name: 'User Activity Report',
                    state: 'userActivityReport',
                    view: 'userActivityReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '113',
                    name: 'Tracking Discrepancy',
                    state: 'trackingDiscrepancy',
                    view: 'trackingDiscrepancyView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '114',
                    name: 'Language Discrepancy',
                    state: 'languageDiscrepancy',
                    view: 'languageDiscrepancyView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '115',
                    name: 'Male/Female Discrepancy',
                    state: 'maleFemaleDiscrepancy',
                    view: 'maleFemaleDiscrepancyView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '116',
                    name: 'SMS Manager',
                    state: 'smsManager',
                    view: 'smsManagerView',
                    closable : false,
                    pageBelongsToTheMenu : 'messageAdmin'
                  },
                  {
                    id: '117',
                    name: 'Crew Violations',
                    state: 'crewViolations',
                    view: 'crewViolationsView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '118',
                    name: 'Cosmic Radiation',
                    state: 'cosmicRadiation',
                    view: 'cosmicRadiationView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'settings'
                  },
                  {
                    id: '119',
                    name: 'Cosmic Radiation Report',
                    state: 'cosmicRadiationReport',
                    view: 'cosmicRadiationReportView',
                    closable : false,
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '120',
                    name: 'ATC Call Sign Conversion',
                    state: 'atcCallSign',
                    view: 'atcCallSignView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'settings'
                  },
                  {
                    id: '121',
                    name: 'Crew Positions Report',
                    state: 'crewPositionsReport',
                    view: 'crewPositionsReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '122',
                    name: 'Operations Summary Report',
                    state: 'operationsSummaryReport',
                    view: 'operationsSummaryReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '123',
                    name: 'Roster Scoring Report',
                    state: 'rosterScoringReport',
                    view: 'rosterScoringReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'},
                  {
               	   id: '123',
               	   name: 'Snap',
               	   state: 'snap',
               	   view: 'snapView',
               	   closable : false,
               	   favicon : 'favicon_crew_roster.ico',
               	   pageBelongsToTheMenu : 'settings'
                  },
                  {
                    id: '124',
                    name: 'Pairing Compliments',
                    state: 'pairingCompliments',
                    view: 'pairingComplimentsView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'settings'
                  },
                  {
                  	 id: '125',
                  	 name: 'Commander Discretion',
                  	 state: 'adminCommanderDiscretion',
                  	 view: 'adminCommanderDiscretionView',
                  	 closable : false,
                  	 favicon : 'favicon_crew_roster.ico',
                  	 pageBelongsToTheMenu : 'flight'
                   },
                  {
                    id: '126',
                    name: 'Crew Standby Report',
                    state: 'crewStandByReport',
                    view: 'crewStandByReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '127',
                    name: 'Crew Pairing Report',
                    state: 'crewPairingReport',
                    view: 'crewPairingReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '128',
                    name: 'Annual Leave Bidding',
                    state: 'annualLeaveBidding',
                    view: 'annualLeaveBiddingView',
                    closable : false,
                    favicon : 'favicon_crew_schedule.ico',
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '129',
                    name: 'Consecutive Day & Early Morning Flight',
                    state: 'consecutiveDayFlightAndEarlyMorningDeparture',
                    view: 'dayAndEarlyMorningFlightView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '130',
                    name: 'Double Sector in Rolling 7 Days',
                    state: 'doubleSectorInRollingSevenDays',
                    view: 'doubleSectorInRollingSevenDaysView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '131',
                    name: 'Consecutive Morning and Night flight',
                    state: 'morningFlightAfterNightFlight',
                    view: 'morningFlightAfterNightFlightView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '132',
                    name: 'RKT Departure Min Rest Not Achieved',
                    state: 'minRestBreachPriorToRktDeparture',
                    view: 'minRestBreachPriorToRktDepartureView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '133',
                    name: 'Multiple Flight in Rolling 7 Days',
                    state: 'multipleFlightsInRollingSevenDays',
                    view: 'multipleFlightsInRollingSevenDaysView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '134',
                    name: 'Double Sector Count',
                    state: 'doubleSectorCount',
                    view: 'doubleSectorCountView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '135',
                    name: 'Morning Flight prior to Layover/Night',
                    state: 'morningFlightPriorToLayoverNight',
                    view: 'morningFlightPriorToLayoverNightView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '136',
                    name: 'Double Sector prior to Day Turnaround',
                    state: 'doubleSectorPriorToDayTurnaround',
                    view: 'doubleSectorPriorToDayTurnaroundView',
                    closable : false,
                    pageBelongsToTheMenu : 'crews'
                  },
                  {
                    id: '137',
                    name: 'Payroll Duty Summary Report',
                    state: 'payrollDutySummary',
                    view: 'payrollDutySummaryView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico'
                  },
                  {
                    id: '138',
                    name: 'Roster Status Report Analysis',
                    state: 'rosterStatusReportRadarChart',
                    view: 'rosterStatusReportRadarChartView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico'
                  },
                  {
                    id: '151',
                    name: 'Sales Target',
                    state: 'salesTarget',
                    view: 'salesTargetView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico'
                  },
                  {
                    id: '150',
                    name: 'Planned Vs Actual Payment Report',
                    state: 'paymentPlannedActual',
                    view: 'paymentView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico'
                  },
                  {
                    id: '140',
                    name: 'Crew Schedule Change Report',
                    state: 'crewScheduleChangeReport',
                    view: 'crewScheduleChangeReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '152',
                    name: 'Map Pairing Groups',
                    state: 'mapPairingGroups',
                    view: 'mapPairingGroupsView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico'
                  },
                  {
                    id: '153',
                    name: 'SIM Utilization Report',
                    state: 'simUtilizationReport',
                    view: 'simUtilizationReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico'
                  },
                  {
                    id: '154',
                    name: 'Station Flight Handling',
                    state: 'stationFlightHandling',
                    view: 'stationFlightHandlingView',
                    closable : false,
                    favicon : 'favicon_crew_watch.ico',
                    pageBelongsToTheMenu : 'flight'},

                  {id: '155',
                    name: 'Layover Summary Report',
                    state: 'layoverSummaryReport',
                    view: 'layoverSummaryReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'

                  },
                  {
                    id: '156',
                    name: 'Crew Credit Hours Details Report',
                    state: 'crewCreditHoursReport',
                    view: 'crewCreditHoursReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '157',
                    name: 'Individual Crew Expiry Report',
                    state: 'individualCrewExpiryReport',
                    view: 'individualCrewExpiryReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '158',
                    name: 'FDP Exceedance Report',
                    state: 'fdpExceedanceReport',
                    view: 'fdpExceedanceReportView',
                    closable : false,
                    favicon : 'favicon_crew_roster.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                  {
                    id: '159',
                    name: 'Crew Voyage Report',
                    state: 'crewVoyageReport',
                    view: 'crewVoyageReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'

                  },
                  {
                    id: '160',
                    name: 'Crew Hotac Report',
                    state: 'crewHotacReport',
                    view: 'crewHotacReportView',
                    closable : false,
                    favicon : 'favicon_create_pairing.ico',
                    pageBelongsToTheMenu : 'reports'
                  },
                ]
            };

        /**
		 * Set Login Time Stamp
		 */
        self.setLastTokenReceivedTimestamp = function () {
            lastTokenRecivedTimeStamp = moment().toISOString();
            StorageServices.set(StorageServices.KEYS.LAST_TOKEN_RECEIVED_TIMESTAMP, lastTokenRecivedTimeStamp);
        };

        /**
         * Get Login Timestamp
         * @returns {*}
         */
        self.getLastTokenReceivedTimestamp = function () {
            if (!!lastTokenRecivedTimeStamp) {
                return lastTokenRecivedTimeStamp;
            } else {
                return lastTokenRecivedTimeStamp = StorageServices.get(StorageServices.KEYS.LAST_TOKEN_RECEIVED_TIMESTAMP);
            }
        };

        /**
         * Set Last Service call time Stamp
         */
        self.setLastServiceCallTime = function () {
            lastServiceCallTimeStamp = moment().toISOString();
            StorageServices.set(StorageServices.KEYS.LAST_SERVER_CALL_TIMESTAMP, lastServiceCallTimeStamp);
        };

        /**
         * Get Last Service call timestamp
         * @returns {*}
         */
        self.getLastServiceCallTime = function () {
            return lastServiceCallTimeStamp = StorageServices.get(StorageServices.KEYS.LAST_SERVER_CALL_TIMESTAMP);
        };

        /**
         * Set Login Response Data
         * @param loginInfoParam
         */
        self.setLoginInfo = function (loginInfoParam) {
            loginInfo = loginInfoParam;
            StorageServices.set(StorageServices.KEYS.LOGIN_INFO, loginInfo);
        };

        /**
         * Get User Login Info
         * @returns {*}
         */
        self.getLoginInfo = function () {
//            if (loginInfo) {
//                return loginInfo;
//            } else {
                return loginInfo = StorageServices.get(StorageServices.KEYS.LOGIN_INFO);
//            }
        };

        /**
         * Get Token ID
         * @returns {*}
         */
        self.getTokenId = function () {
//            if (!loginInfo) {
            loginInfo = StorageServices.get(StorageServices.KEYS.LOGIN_INFO);
//            }
            return loginInfo && loginInfo.tokenId;
        };

        self.getTenantCode = function () {
//          if (!loginInfo) {
           loginInfo = StorageServices.get(StorageServices.KEYS.LOGIN_INFO);
//          }
          return loginInfo && loginInfo.tenantCode;
        };

        self.removeTab = function (tab) {
            var index = _.findIndex(tabSettings.allOpenTabs, function (item) {
                return item.state == tab.state
            });
            tabSettings.allOpenTabs.splice(index, 1);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TAB_REMOVED);
        };

        self.getSelectedTab = function () {
            return tabSettings.selectedTab || (tabSettings.allOpenTabs.length && tabSettings.allOpenTabs[0].state);
        };

        self.getSelectedTabByState = function (state) {
            var obj = null
            for (var i=0;i<tabSettings.allTabbableState.length;i++){
                if(tabSettings.allTabbableState[i].state===state){
                    obj = tabSettings.allTabbableState[i];
                    break;
                }
            }
            return obj;
        };

        self.setSelectedTab = function (state) {
            if (state != tabSettings.selectedTab) {
                tabSettings.selectedTab = state;
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TAB_SELECTED);
            }
        };

        self.openInTabbedView = function (toState) {
            var isTabbable = _.findWhere(tabSettings.allTabbableState, {state: toState});

            if (!!isTabbable) {
                var isTabAvailable = _.findIndex(tabSettings.allOpenTabs, function (item) {
                        return item.state == toState
                    }) >= 0;
                if (!isTabAvailable) {
                    tabSettings.allOpenTabs.push(isTabbable);
                }
                self.setSelectedTab(toState);
            }
        };

        self.getAllOpenTabs = function () {
            return tabSettings.allOpenTabs;
        };

        self.closeAllOpenTabs = function(){
            tabSettings.allOpenTabs.length = 0;
        };

    };


}());
